import { CommonModule } from '@angular/common';
import {
    Component,
    OnInit,
    Input,
    ChangeDetectionStrategy,
    Inject,
    signal
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef
} from '@angular/material/dialog';

/** Datos del diálogo de confirmación (los cuatro campos son obligatorios para mostrar el modal). */
export interface ModalAskStepData {
    title: string;
    message: string;
    buttonFalse: string;
    buttonTrue: string;
}

@Component({
    selector: 'app-modal-ask-step',
    templateUrl: './modal-ask-step.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatTooltipModule,
        MatDialogModule
    ],
    changeDetection: ChangeDetectionStrategy.Default
})
export class ModalAskStepComponent implements OnInit {
    public title = signal<string>(null);
    public message = signal<string>(null);
    public buttonFalse = signal<string>(null);
    public buttonTrue = signal<string>(null);

    constructor(
        @Inject(MAT_DIALOG_DATA) public _data: ModalAskStepData,
        private _matDialogRef: MatDialogRef<ModalAskStepComponent>
    ) {}

    ngOnInit() {
        if (
            this._data.title &&
            this._data.message &&
            this._data.buttonFalse &&
            this._data.buttonTrue
        ) {
            this.title.set(this._data.title);
            this.message.set(this._data.message);
            this.buttonFalse.set(this._data.buttonFalse);
            this.buttonTrue.set(this._data.buttonTrue);
        }
    }

    close(data: boolean) {
        this._matDialogRef.close(data);
    }
}
